// export function armaMailAdministracion(
//   factibilidad,
//   sendAdministracion
// ) {
//   const mail = `
// <div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
//   <p style="color: #333;"><strong>📝 Nueva Factibilidad Aprobada </strong></p>

//   <p style="color: #333;">
//     en el siguiente enlace se muestran los datos del cliente que hay que registrar en sisven
//     ademas tambien se necesita que el sector administrativo complete el id de sisven para poder dar completamente de alta el nuevo cliente
//     ya se q esta horrible redactado pero es solamente para hacer las pruebas.
//   </p>

//   <p style="margin-top: 20px;">
//     <a href="http://localhost:3000/#/factibilidades/form_administracion/${factibilidad.factuuid}"
//        style="display: inline-block; padding: 10px 20px; background-color: #1976d2; color: #fff !important; text-decoration: none; border-radius: 5px; font-weight: bold;">
//       ✅ Completar Datos 
//     </a>
//   </p>
// </div>
// `
//   return mail;
// }

export function armaMailAdministracion(factibilidad, sendAdministracion, urlAutorizacion) {

  // console.log("URL" , `${urlAutorizacion}${factibilidad.factuuid}`)
  const url = `${urlAutorizacion}${factibilidad.factuuid}`;
  // console.log("url", url);
  
  const textoAdministracionNuevoCliente = `

    <p style="color: #333;">
      Para poder dar de alta el cliente, sus domicilios y poder despachar el tanque, es necesario que el sector administrativo complete el <strong>SISVEN ID</strong> del cliente.
    </p>

    <p style="color: #333;">
      En el siguiente enlace van a encontrar todos los datos del cliente necesarios para registrarlo en Sisven. 
      Allí también podrán completar el número de Sisven del cliente una vez que haya sido registrado.
    </p>

    <p style="color: #333;">
      Una vez que se haya completado el SISVEN ID, se dará de alta el cliente en Netizar y se generará un reclamo por la instalación del tanque.
    </p>
  `;

  const textoComun = `

    <p style="color: #333;">
      En el siguiente enlace podrán encontrar la información de la factibilidad y el domicilio para la cual fue confeccionada.
    </p>
  `;

  const mail = `
    <div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
      <p style="color: #333;"><strong>📝 Nueva Factibilidad Aprobada</strong></p>

      ${sendAdministracion == 1 && factibilidad.id_tipofact == 235 ? textoAdministracionNuevoCliente : textoComun}

      <p style="margin-top: 20px;">
        <a href="${url}"
          style="display: inline-block; padding: 10px 20px; background-color: #1976d2; color: #fff !important; text-decoration: none; border-radius: 5px; font-weight: bold;">
          ✅ Ver Factibilidad
        </a>
      </p>
    </div>
  `;

  return mail;
}
